import { useTranslation } from 'react-i18next';

import Button from '@/components/ui/Button';
import styles from './fundAllocationTabs.module.scss';

export const PAGE_SIZE = 25;

/**
 * Client-side pager for the classification tables. 500 rows in one run put the horizontal
 * scrollbar a full page-scroll away; 25-row pages keep every control within reach.
 */
const TablePager = ({ page, pageCount, onChange }: { page: number; pageCount: number; onChange: (page: number) => void }) => {
  const { t } = useTranslation();

  if (pageCount <= 1) return null;

  return (
    <div className={styles.pager}>
      <Button variant="outline" disabled={page === 0} onClick={() => onChange(page - 1)}>
        {t('nedarimTransactionsFundAllocation.tabs.pagerPrev')}
      </Button>
      <span className={`body-sm-regular ${styles.pagerLabel}`}>
        {t('nedarimTransactionsFundAllocation.tabs.pagerLabel', { page: page + 1, total: pageCount })}
      </span>
      <Button variant="outline" disabled={page >= pageCount - 1} onClick={() => onChange(page + 1)}>
        {t('nedarimTransactionsFundAllocation.tabs.pagerNext')}
      </Button>
    </div>
  );
};

export default TablePager;
